<template>
  <div>
    <footer>
      <div class="home">
        <ul class="clearfix">
          <li>
            <a
              data-v-1442be80=""
              href="http://company.drcnet.com.cn/about.html"
              target="_blank"
              >关于我们</a
            >
          </li>
          <li>
            <a href="http://misc.drcnet.com.cn/us/wangzsm.aspx" target="_blank"
              >网站声明</a
            >
          </li>
          <li>
            <a
              data-v-1442be80=""
              href="http://company.drcnet.com.cn/cpyc.html#/recruit"
              target="_blank"
              >诚聘英才</a
            >
          </li>
          <li>
            <a
              class="a"
              href="http://misc.drcnet.com.cn/us/guanggrx.aspx"
              target="_blank"
              >广告热线</a
            >
          </li>
          <li>
            <a
              href="http://company.drcnet.com.cn/lxwm.html#/contact"
              target="_blank"
              >联系我们</a
            >
          </li>
          <li>
            <a
              class="a"
              href="http://misc.drcnet.com.cn/us/youqlj.aspx"
              target="_blank"
              >友情链接</a
            >
          </li>
          <li>
            <a class="a" href="http://www.drcnet.com.cn/#">设为首页</a>
          </li>
          <li>
            <a
              class="a"
              href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserMain.aspx"
              target="_blank"
              >会员专区</a
            >
          </li>
          <li>
            <a
              href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx"
              target="_blank"
              >意见和建议</a
            >
          </li>
          <li>
            <a href="mailto:chiefeditor@drcnet.com.cn" target="_blank"
              >总监信箱</a
            >
          </li>
        </ul>
        <a href="http://www.drcnet.com.cn/www/int/" target="_blank" class="logo"
          ><img src="./images/FooterLogo.png"
        /></a>
        <p class="address">
          <span
            >Copyright©1998-{{ new Date().getFullYear() }} DRCnet. All Rights
            Reserved 版权所有 国研网</span
          ><img src="./images/Shield.png" />
        </p>
      </div>
      <div class="bottom" v-if="windowWidth <= 769">
        <p class="home clearfix">
          <span>增值电信业务经营许可证 京ICP证030059号</span
          ><span>增值电信业务经营许可证 京B2-20070136</span
          ><span>出版物经营许可证 新出发京批字第直210398号</span
          ><span>京公网安备 11010102002958号</span
          ><img src="./images/Record.png" class="fl" /><span
            style="float: right"
            >建议浏览器：火狐、谷歌</span
          >
        </p>
      </div>
    </footer>
    <div class="bottom" v-if="windowWidth > 769">
      <p class="home clearfix">
        <span>增值电信业务经营许可证 京ICP证030059号</span
        ><span>增值电信业务经营许可证 京B2-20070136</span
        ><span>出版物经营许可证 新出发京批字第直210398号</span
        ><span>京公网安备 11010102002958号</span
        ><img src="./images/Record.png" class="fl" /><span style="float: right"
          >建议浏览器：火狐、谷歌</span
        >
      </p>
    </div>
  </div>
</template>

<script>
import { getNav, getUserSubscribe, getUserConfig } from "@/api/axiosApi";
export default {
  // created() {
  //   this.getJsonFile();
  // },
  // methods: {
  //   async getJsonFile() {
  //     const data = await getUserConfig();
  //     if (data.data) {
  //       localStorage.setItem(
  //         "FreeNav",
  //         JSON.stringify(data.data[1].defaultContent)
  //       );
  //       localStorage.setItem(
  //         "BannerConfigData",
  //         JSON.stringify(data.data[0].banner)
  //       );
  //       localStorage.setItem("stylestate", data.data[2].itemColor);
  //     } else {
  //       this.items = {};
  //     }
  //   },
  // },
};
</script>

<style lang="less" scoped>
footer {
  background: #272e39;
  height: 169px;
  overflow: hidden;
  text-align: center;

  .home {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    ul {
      margin: 27px auto 16px;
      width: 813px;
      list-style: none;
      li {
        float: left;
        a {
          color: #fff;
          line-height: 100%;
          font-size: 14px;
          font-family: Microsoft YaHei;
          padding: 0 10px;
        }
      }
    }
    .clearfix::after {
      content: "";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }
    .logo {
      display: inline-block;
    }
    .address {
      text-align: center;
      margin-top: 15px;
      span {
        font-size: 13px;
        font-family: Microsoft YaHei;
        color: #fff;
        line-height: 23px;
      }
    }
  }
}
.bottom {
  width: 100%;
  height: 44px;
  background: #1d232d;
  .home {
    width: 1200px;
    box-sizing: border-box;
    margin: 0 auto;
    span {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #909295;
      line-height: 44px;
      float: left;
      margin-right: 18px;
    }
  }
  img {
    margin-top: 10px;
  }
  .clearfix {
    zoom: 1;
  }
}
.fl {
  float: left;
}
footer ul li:not(:last-child)::after {
  //   border-left: 1px solid #fff;
  content: "|";
  color: #fff;
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
  footer {
    height: auto !important;
  }
  .address {
    padding: 0 16px;
  }
  .home {
    width: 100% !important;
    span {
      float: none !important;
      display: inline-block;
      margin: 0 auto;
    }
    ul {
      width: 100% !important;
      li {
        float: none !important;
        display: inline-block;
      }
    }
  }
  .bottom {
    height: auto !important;
  }
}
</style>